import { RequestOptions } from '@nirvana/shared/websocket-client';

const preCallDefaultHook = request => {
  if (!document?.body) {
    return;
  }

  const progressElement = document.createElement('div');
  progressElement.id = request.id + ':' + request.method;
  progressElement.classList.add('ajax-request');
  document.body.appendChild(progressElement);
};

const postCallDefaultHook = (error, request, response) => {
  if (!document?.body) {
    return;
  }

  const progressElement = document.getElementById(request.id + ':' + request.method);

  if (!progressElement || !progressElement.parentNode) {
    return;
  }

  progressElement.parentNode.removeChild(progressElement);
};

export function getRequestDefaultOptions(): RequestOptions {
  return {
    requestTimeout: 60000,
    preCallHook: preCallDefaultHook,
    postCallHook: postCallDefaultHook,
  };
}
